import { ApiService } from './api.service'

const BaseUrl = '/inquiry'

export function sendInquiry (params = {}) {
  return ApiService.post(`${BaseUrl}`, params).then(resp => resp)
}
